module.exports = __webpack_public_path__ + "static/cloaker-b86db26fabb91820e769d804ac5a52e9.jpeg";